import { render } from "./BlogPostDetails.vue?vue&type=template&id=352e7389&scoped=true"
import script from "./BlogPostDetails.vue?vue&type=script&lang=js"
export * from "./BlogPostDetails.vue?vue&type=script&lang=js"

import "./BlogPostDetails.vue?vue&type=style&index=0&id=352e7389&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352e7389"]])

export default __exports__